import { StyleSheet} from 'aphrodite';
export const styles = StyleSheet.create({
    App :{
        margin: 0,
        height: "100%"
    }
});


// WEBPACK FOOTER //
// ./src/styles/App.ts